// Regeln für Skizzen-Dateien (C7). Ohne Imports, weil auch der Server
// diese Datei lädt (server/lib/sketches.js). Grenzen wie Bucket-Regeln (017).

export const SKETCH_TYPES = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
  'image/gif': 'gif'
};
export const SKETCH_MAX_BYTES = 5 * 1024 * 1024;
export const SKETCH_ACCEPT = Object.keys(SKETCH_TYPES).join(',');

/** Fehlertext für den Nutzer oder null, wenn die Datei passt. */
export function checkSketchFile(file) {
  if (!file || !SKETCH_TYPES[file.type]) return 'Nur PNG, JPEG, WebP oder GIF.';
  if (file.size > SKETCH_MAX_BYTES) return 'Skizze zu groß (max. 5 MB).';
  return null;
}

/** Dateiendung aus dem MIME-Typ (eingefügte Bilder haben oft keinen Namen). */
export function sketchExt(type) {
  return SKETCH_TYPES[type] || 'png';
}

const MARKER = '/storage/v1/object/public/sketches/';

/** Pfad im Bucket „sketches“ aus der Public-URL, sonst null. */
export function sketchPathFromUrl(url) {
  if (typeof url !== 'string') return null;
  let pathname;
  try { pathname = new URL(url).pathname; } catch { return null; }
  const i = pathname.indexOf(MARKER);
  if (i === -1) return null;
  let path;
  try { path = decodeURIComponent(pathname.slice(i + MARKER.length)); } catch { return null; }
  if (!path) return null;
  if (path.split('/').some((seg) => seg === '' || seg === '.' || seg === '..')) return null;
  return path;
}
